var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.propertyModified())?_c('ButtonIcon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('resetButton.reset')),expression:"$t('resetButton.reset')"}],attrs:{"tooltip-position":"bottom-left","icon":"iconoir-erase"},on:{"click":function($event){return _vm.resetProperty()}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }